import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cards-grid gap-x-[32px] gap-y-[36px] px-1 my-4 md:mb-6 xl:mb-10 md:mt-10 justify-center sm:grow" }


import BlogCard from "@/views/Blogs/components/BlogCard/BlogCard.vue";
import { BlogCardItem } from "@/types/blogs";


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogGrid',
  props: {
    blogList: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.blogList, (blogCard) => {
      return (_openBlock(), _createBlock(BlogCard, {
        blog: blogCard,
        key: blogCard.id
      }, null, 8, ["blog"]))
    }), 128))
  ]))
}
}

})